export const THEME = {
  DEFAULT: 'RED',
  RED: 'RED',
};
